(() => {
  const syncGroupQuantity = async (group, quantity) => {
    if (!group) return false;
    const cart = await fetch(`${window.Shopify?.routes?.cart_url || '/cart'}.json`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties?._artes_personalization_group === group) {
        const multiplier = Math.max(1, Number(item.properties?._artes_personalization_multiplier || 1));
        updates[item.key] = quantity * multiplier;
      }
    });
    // A personalized line can occasionally be left without its helper lines (for
    // example after an interrupted/older add-to-cart flow). In that case we still
    // update/remove the remaining line instead of trapping it in the cart.
    if (Object.keys(updates).length === 0) return false;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    window.location.reload();
    return true;
  };

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('cart-remove-button[data-personalization-group]');
    if (removeButton && removeButton.dataset.personalizationGroup) {
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        await syncGroupQuantity(removeButton.dataset.personalizationGroup, 0);
      } catch (error) {
        console.error('Personalization removal failed', error);
        window.location.reload();
      }
      return;
    }
  }, true);

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('input[data-personalization-group]');
    if (!input || !input.dataset.personalizationGroup) return;
    if (input.disabled) return;
    const quantity = Math.max(0, Number(input.value || 0));
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await syncGroupQuantity(input.dataset.personalizationGroup, quantity);
    } catch (error) {
      console.error('Personalization quantity sync failed', error);
      window.location.reload();
    }
  }, true);
})();
